import { motion } from "framer-motion";

export function SectionTitle({ eyebrow, title, kicker, dark = false, align = "left" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <div className={dark ? "eyebrow-dark mb-4" : "eyebrow mb-4"} data-testid="section-eyebrow">
          {eyebrow}
        </div>
      )}
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className={`font-display font-bold tracking-tighter leading-[0.95] text-3xl sm:text-5xl lg:text-6xl ${
          dark ? "text-[#050505]" : "text-white"
        }`}
        data-testid="section-title"
      >
        {title}
      </motion.h2>
      {kicker && (
        <p className={`mt-6 text-base sm:text-lg max-w-2xl ${dark ? "text-black/70" : "text-white/70"}`}>
          {kicker}
        </p>
      )}
    </div>
  );
}

export function StatNumber({ value, label, dark }) {
  return (
    <div>
      <div className={`font-display text-4xl sm:text-5xl font-bold tracking-tighter ${dark ? "text-[#050505]" : "text-white"}`}>
        {value}
      </div>
      <div className={`mt-2 text-sm ${dark ? "text-black/60" : "text-white/60"}`}>{label}</div>
    </div>
  );
}
